import { render } from "./VanIcon.vue?vue&type=template&id=2744b47a"
import script from "./VanIcon.vue?vue&type=script&lang=js"
export * from "./VanIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__